// Thin wrapper around the New Relic Browser agent's global API. The agent
// injects `window.newrelic` itself (see config/newrelic.yml
// browser_monitoring.auto_instrument and app/views/shared/_head.html.erb) -
// this file never loads or configures it, only calls it defensively.
interface NewRelicBrowserAgent {
  setCurrentRouteName?: (name: string) => void
}

declare global {
  interface Window {
    newrelic?: NewRelicBrowserAgent
  }
}

// Names the current Browser Pro+SPA route/interaction after the app's own
// page identifier (e.g. "VouchersIndex") instead of the raw URL, which would
// otherwise include record ids and turn every navigation into a distinct,
// high-cardinality route. Safe to call whether or not the Browser agent is
// present (local dev, or Browser not yet enabled for this app in New Relic).
export function setBrowserRouteName(pageName: string): void {
  try {
    window.newrelic?.setCurrentRouteName?.(pageName)
  } catch {
    // Never let telemetry break page navigation.
  }
}
